/// <amd-module name="Core/Medius.Core.Web/Scripts/components/emailStatusTab/common/recipientGroup"/>
import * as React from 'react';
import { Text, FixedGridLayout, GridLayoutItem } from '@medius/ui-controls';

export interface RecipientDisplayItem {
    emailAddress: string;
    statusIcon: React.ReactNode;
}

export interface RecipientGroupProps {
    label: string;
    recipients: RecipientDisplayItem[];
    layout?: 'flex' | 'grid';
    dataTestId?: string;
}

export const RecipientGroup = ({
    label,
    recipients,
    layout = 'flex',
    dataTestId,
}: RecipientGroupProps): React.ReactElement | null => {
    if (recipients.length === 0) return null;

    const renderRecipients = () => (
        <div className="recipient-items">
            {recipients.map((recipient, index) => (
                <div key={index} className="recipient-item">
                    {recipient.statusIcon}
                    <Text
                        variant="body"
                        className="recipient-email"
                        data-testid="recipient-email-address"
                    >
                        {recipient.emailAddress}
                    </Text>
                </div>
            ))}
        </div>
    );

    if (layout === 'grid') {
        return (
            <FixedGridLayout columns={11} itemRowSpacing="none" data-testid={dataTestId}>
                <GridLayoutItem column={1} columnSpan={1}>
                    <Text variant="heading3">{label}</Text>
                </GridLayoutItem>
                <GridLayoutItem column={2} columnSpan={10}>
                    {renderRecipients()}
                </GridLayoutItem>
            </FixedGridLayout>
        );
    }

    return (
        <div className="recipient-group" data-testid={dataTestId}>
            <Text variant="body" id="recipient-group__label">
                {label}:
            </Text>
            <div className="recipient-group__list">{renderRecipients()}</div>
        </div>
    );
};
